var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArgosInstancesPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.18 33.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #8a397e;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.26,1h27.65c3.86,0,7,3.14,7,7v21.31H6.26V8c0-3.86,3.14-7,7-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.18,29.31H1c0,2,1.62,3.62,3.62,3.62h44.93c2,0,3.62-1.62,3.62-3.62h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.95 22.33 26.52 12.97 26.52 26.22 30.47 22.42 35.95 22.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.52,
    y1: 8.81,
    x2: 26.52,
    y2: 7.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.59,
    y1: 10.03,
    x2: 22.58,
    y2: 9.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.37,
    y1: 12.97,
    x2: 20.95,
    y2: 12.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.59,
    y1: 15.91,
    x2: 22.58,
    y2: 16.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.68,
    y1: 12.97,
    x2: 32.1,
    y2: 12.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.46,
    y1: 10.03,
    x2: 30.47,
    y2: 9.03
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgosInstancesPurple);
export default __webpack_public_path__ + "static/media/Argos - Instances - Purple.c7aeba72ba18707c123232c3f3b9f0b4.svg";
export { ForwardRef as ReactComponent };